module.exports = __webpack_public_path__ + "img/livecasino.55692193.png";